import React from "react";
import ReactDOM from "react-dom";
import { Section, Box, Heading, Paragraph, Image, Video, Label } from "grommet";

import screenshot from "./screenshot.png";
import video from "./video.mp4";

const Camry = props => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        Toyota Camry Configurator
      </Heading>
    ) : null}
    <Box direction="row" size={{ width: "xxlarge" }}>
      <Box
        direction="column"
        basis="2/3"
        margin="small"
        textAlign="left"
        align="center"
      >
        <Video
          size="large"
          autoPlay={true}
          loop={true}
          showControls={false}
          allowFullScreen={false}
        >
          <source src={video} type="video/mp4" />
        </Video>
        <Paragraph>
          This is a WebGL configurator project I was involved in at Rotor
          Studios. This experience allows the user to view and configure the new
          Toyota Camry. For this configurator we used ThreeJS instead of
          Blend4Web. ThreeJS allows a lot of flexibility, but isn't very artist
          friendly and requires some manual work to establish a good workflow.
          Within a short time we were able to get much better visual quality
          then our Blend4Web configurators.
        </Paragraph>
        <Paragraph>
          I was responsible for the design and implementation of our internal
          ThreeJS engine and its associated workflows. Since this engine would
          be used by artists I wanted to avoid them having to create scenes in
          javascript. I chose to use AFrame since it provides a workflow similar
          to Unreal and Unity with its entity component architecture and runtime
          inspector tools. With AFrame artists could either import gltf scenes
          or write scenes declaratively in html, which is a bit better then
          writing scenes in javascript.
        </Paragraph>
      </Box>
      <Box direction="column" basis="1/3" justify="left" textAlign="left">
        <Paragraph>
          Some of the features implemented in the ThreeJS engine were:
        </Paragraph>
        <ul>
          <li>Image based lighting with HDR cubemaps.</li>
          <li>Draco compression for vehicle meshes.</li>
          <li>Post Processing effects stack including DOF and SMAA T2x.</li>
        </ul>
        <Image src={screenshot} size="medium" />
        <Paragraph size="small">
          To try it click here:{" "}
          <a href="https://customise.toyota.com.au/camry/">
            https://customise.toyota.com.au/camry/
          </a>
        </Paragraph>
      </Box>
    </Box>
  </Section>
);

export default Camry;



// WEBPACK FOOTER //
// ./src/components/projects/camry/camry.js